import createRemoteSourceListAction from 'api/actions/remote-source-list/remote-source-list-action';
import createRemoteSourceGetAction from 'api/actions/remote-source-get/remote-source-get-action';
import createRemoteSourceCreateAction from 'api/actions/remote-source-create/remote-source-create-action';
import createRemoteSourceUpdateAction from 'api/actions/remote-source-update/remote-source-update-action';
import createRemoteSourceSetStatusAction from 'api/actions/remote-source-set-status/remote-source-set-status-action';
import createRemoteSourceUpdateConfigAction from 'api/actions/remote-source-update-config/remote-source-update-config-action';
import createRemoteSourceSyncDeviceAction from 'api/actions/remote-source-sync-device/remote-source-sync-device-action';
import createXlsxImportDeviceAction from 'api/actions/xlsx-import-device/xlsx-import-device-action';
import createXlsxImportRevisionPlanAction from 'api/actions/xlsx-import-revision-plan/xlsx-import-revision-plan-action';
import createXlsxImportDeviceFaultAction from 'api/actions/xlsx-import-device-fault/xlsx-import-device-fault-action';
import createMeasuringDeviceListAction from 'api/actions/measuring-device-list/measuring-device-list-action';
import createMeasuringDeviceGetAction from 'api/actions/measuring-device-get/measuring-device-get-action';
import createMeasuringDeviceCreateAction from 'api/actions/measuring-device-create/measuring-device-create-action';
import createMeasuringDeviceUpdateAction from 'api/actions/measuring-device-update/measuring-device-update-action';
import createMeasuringDeviceDeleteAction from 'api/actions/measuring-device-delete/measuring-device-delete-action';
import createMeasuringDeviceRevisionGetAction from 'api/actions/measuring-device-revision-get/measuring-device-revision-get-action';
import createPredefinedDataListUsersAction from 'api/actions/predefined-data-list-users/predefined-data-list-users-action';
import createPredefinedDataListGlobalAction from 'api/actions/predefined-data-list-global/predefined-data-list-global-action';
import createPredefinedDataGetUsersAction from 'api/actions/predefined-data-get-users/predefined-data-get-users-action';
import createPredefinedDataGetGlobalAction from 'api/actions/predefined-data-get-global/predefined-data-get-global-action';
import createPredefinedDataCreateUsersAction from 'api/actions/predefined-data-create-users/predefined-data-create-users-action';
import createPredefinedDataCreateGlobalAction from 'api/actions/predefined-data-create-global/predefined-data-create-global-action';
import createPredefinedDataUpdateUsersAction from 'api/actions/predefined-data-update-users/predefined-data-update-users-action';
import createPredefinedDataUpdateGlobalAction from 'api/actions/predefined-data-update-global/predefined-data-update-global-action';
import createPredefinedDataDeleteUsersAction from 'api/actions/predefined-data-delete-users/predefined-data-delete-users-action';
import createPredefinedDataDeleteGlobalAction from 'api/actions/predefined-data-delete-global/predefined-data-delete-global-action';
import createPredefinedDataListTypesAction from 'api/actions/predefined-data-list-types/predefined-data-list-types-action';
import createPredefinedDataListRevisionDataAction from 'api/actions/predefined-data-list-revision-data/predefined-data-list-revision-data-action';
import createPredefinedDataGetMixedAction from 'api/actions/predefined-data-get-mixed/predefined-data-get-mixed-action';
import createDeviceListEvidenceFieldSectionsAction from 'api/actions/device-list-evidence-field-sections/device-list-evidence-field-sections-action';
import createDeviceCreateEvidenceFieldSectionAction from 'api/actions/device-create-evidence-field-section/device-create-evidence-field-section-action';
import createDeviceUpdateEvidenceFieldSectionAction from 'api/actions/device-update-evidence-field-section/device-update-evidence-field-section-action';
import createDeviceDeleteEvidenceFieldSectionAction from 'api/actions/device-delete-evidence-field-section/device-delete-evidence-field-section-action';
import createDeviceListAction from 'api/actions/device-list/device-list-action';
import createDeviceGetAction from 'api/actions/device-get/device-get-action';
import createDeviceQrCheckAction from 'api/actions/device-qr-check/device-qr-check-action';
import createDeviceQrPairAction from 'api/actions/device-qr-pair/device-qr-pair-action';
import createDeviceQrResolveAction from 'api/actions/device-qr-resolve/device-qr-resolve-action';
import createDeviceCreateAction from 'api/actions/device-create/device-create-action';
import createDeviceUpdateAction from 'api/actions/device-update/device-update-action';
import createDeviceAdminSetRemoteSourceAction from 'api/actions/device-admin-set-remote-source/device-admin-set-remote-source-action';
import createDeviceCanMoveToDepartmentAction from 'api/actions/device-can-move-to-department/device-can-move-to-department-action';
import createDeviceSetStatusAction from 'api/actions/device-set-status/device-set-status-action';
import createDeviceListAllFaultsAction from 'api/actions/device-list-all-faults/device-list-all-faults-action';
import createDeviceListFaultsAction from 'api/actions/device-list-faults/device-list-faults-action';
import createDeviceFaultFixerGetOptionsAction from 'api/actions/device-fault-fixer-get-options/device-fault-fixer-get-options-action';
import createDeviceFaultAuditUserGetOptionsAction from 'api/actions/device-fault-audit-user-get-options/device-fault-audit-user-get-options-action';
import createDeviceMarkFaultFixedAction from 'api/actions/device-mark-fault-fixed/device-mark-fault-fixed-action';
import createDeviceListTypesAction from 'api/actions/device-list-types/device-list-types-action';
import createDeviceListSubtypesAction from 'api/actions/device-list-subtypes/device-list-subtypes-action';
import createDeviceSubtypeCreateAction from 'api/actions/device-subtype-create/device-subtype-create-action';
import createDeviceSubtypeGetAction from 'api/actions/device-subtype-get/device-subtype-get-action';
import createDeviceSubtypeUpdateAction from 'api/actions/device-subtype-update/device-subtype-update-action';
import createDeviceSubtypeSetStatusAction from 'api/actions/device-subtype-set-status/device-subtype-set-status-action';
import createDeviceListRevisionPlanAction from 'api/actions/device-list-revision-plan/device-list-revision-plan-action';
import createDeviceResponsiblePersonGetOptionsAction from 'api/actions/device-responsible-person-get-options/device-responsible-person-get-options-action';
import createDeviceRevisionGetOptionsAction from 'api/actions/device-revision-get-options/device-revision-get-options-action';
import createDeviceActiveTypesAction from 'api/actions/device-active-types/device-active-types-action';
import createDeviceListAllEvidenceFieldsAction from 'api/actions/device-list-all-evidence-fields/device-list-all-evidence-fields-action';
import createDeviceListEvidenceFieldsAction from 'api/actions/device-list-evidence-fields/device-list-evidence-fields-action';
import createDeviceCreateEvidenceFieldAction from 'api/actions/device-create-evidence-field/device-create-evidence-field-action';
import createDeviceUpdateEvidenceFieldAction from 'api/actions/device-update-evidence-field/device-update-evidence-field-action';
import createDeviceDeleteEvidenceFieldAction from 'api/actions/device-delete-evidence-field/device-delete-evidence-field-action';
import createPriceOfferListAction from 'api/actions/price-offer-list/price-offer-list-action';
import createPriceOfferGetAction from 'api/actions/price-offer-get/price-offer-get-action';
import createPriceOfferCreateAction from 'api/actions/price-offer-create/price-offer-create-action';
import createPriceOfferCreateBulkAction from 'api/actions/price-offer-create-bulk/price-offer-create-bulk-action';
import createPriceOfferSubmitAction from 'api/actions/price-offer-submit/price-offer-submit-action';
import createPriceOfferCloseAction from 'api/actions/price-offer-close/price-offer-close-action';
import createPriceOfferReturnAction from 'api/actions/price-offer-return/price-offer-return-action';
import createPriceOfferDeleteAction from 'api/actions/price-offer-delete/price-offer-delete-action';
import createPriceOfferListProvidersAction from 'api/actions/price-offer-list-providers/price-offer-list-providers-action';
import createSystemExportDepartmentFilesAction from 'api/actions/system-export-department-files/system-export-department-files-action';
import createSystemExportListAction from 'api/actions/system-export-list/system-export-list-action';
import createSystemExportCreateAction from 'api/actions/system-export-create/system-export-create-action';
import createSystemExportDeleteAction from 'api/actions/system-export-delete/system-export-delete-action';
import createAuthLoginAction from 'api/actions/auth-login/auth-login-action';
import createAuthLoggedUserInfoAction from 'api/actions/auth-logged-user-info/auth-logged-user-info-action';
import createAuthVerifyTwoFactorLoginAction from 'api/actions/auth-verify-two-factor-login/auth-verify-two-factor-login-action';
import createAuthTwoFactorStartSetupAction from 'api/actions/auth-two-factor-start-setup/auth-two-factor-start-setup-action';
import createAuthTwoFactorConfirmSetupAction from 'api/actions/auth-two-factor-confirm-setup/auth-two-factor-confirm-setup-action';
import createAuthTwoFactorDisableAction from 'api/actions/auth-two-factor-disable/auth-two-factor-disable-action';
import createAuthLogoutAction from 'api/actions/auth-logout/auth-logout-action';
import createAuthLogout_2Action from 'api/actions/auth-logout-2/auth-logout-2-action';
import createAuthForgotPasswordAction from 'api/actions/auth-forgot-password/auth-forgot-password-action';
import createAuthResetPasswordAction from 'api/actions/auth-reset-password/auth-reset-password-action';
import createAuthCheckResetPasswordTokenAction from 'api/actions/auth-check-reset-password-token/auth-check-reset-password-token-action';
import createAuthListRolesAction from 'api/actions/auth-list-roles/auth-list-roles-action';
import createAuthListPermissionsAction from 'api/actions/auth-list-permissions/auth-list-permissions-action';
import createAuthListPermissionTemplatesAction from 'api/actions/auth-list-permission-templates/auth-list-permission-templates-action';
import createAuthListFaultSeveritiesAction from 'api/actions/auth-list-fault-severities/auth-list-fault-severities-action';
import createAuthUserHasPermissionInDepartmentAction from 'api/actions/auth-user-has-permission-in-department/auth-user-has-permission-in-department-action';
import createAuthRemoveUserOrganizationPairsAction from 'api/actions/auth-remove-user-organization-pairs/auth-remove-user-organization-pairs-action';
import createAuthRemoveUserDepartmentPairsAction from 'api/actions/auth-remove-user-department-pairs/auth-remove-user-department-pairs-action';
import createAuthSetUserOrganizationPermissionsAction from 'api/actions/auth-set-user-organization-permissions/auth-set-user-organization-permissions-action';
import createAuthSetUserDepartmentPermissionsAction from 'api/actions/auth-set-user-department-permissions/auth-set-user-department-permissions-action';
import createAuthAddUserOrganizationPairsAction from 'api/actions/auth-add-user-organization-pairs/auth-add-user-organization-pairs-action';
import createAuthAddUserDepartmentPairsAction from 'api/actions/auth-add-user-department-pairs/auth-add-user-department-pairs-action';
import createAuthUserGetPermissionsInDepartmentAction from 'api/actions/auth-user-get-permissions-in-department/auth-user-get-permissions-in-department-action';
import createAuthGetDepartmentsWithPermissionAction from 'api/actions/auth-get-departments-with-permission/auth-get-departments-with-permission-action';
import createAuthGetOrganizationsWithPermissionAction from 'api/actions/auth-get-organizations-with-permission/auth-get-organizations-with-permission-action';
import createAuthLogErrorAction from 'api/actions/auth-log-error/auth-log-error-action';
import createSystemHealthCheckAction from 'api/actions/system-health-check/system-health-check-action';
import createSystemRunCronAction from 'api/actions/system-run-cron/system-run-cron-action';
import createUserListAction from 'api/actions/user-list/user-list-action';
import createUserGetAction from 'api/actions/user-get/user-get-action';
import createUserCreateAction from 'api/actions/user-create/user-create-action';
import createUserUpdateMeAction from 'api/actions/user-update-me/user-update-me-action';
import createUserUpdateMyCertificatesAction from 'api/actions/user-update-my-certificates/user-update-my-certificates-action';
import createUserUpdateMyCompanySettingsAction from 'api/actions/user-update-my-company-settings/user-update-my-company-settings-action';
import createUserUpdateAction from 'api/actions/user-update/user-update-action';
import createUserChangePasswordAction from 'api/actions/user-change-password/user-change-password-action';
import createUserAdminChangePasswordAction from 'api/actions/user-admin-change-password/user-admin-change-password-action';
import createUserAdminSetPasswordValidityAction from 'api/actions/user-admin-set-password-validity/user-admin-set-password-validity-action';
import createUserSetStatusAction from 'api/actions/user-set-status/user-set-status-action';
import createUserGetNotificationSettingsAction from 'api/actions/user-get-notification-settings/user-get-notification-settings-action';
import createUserUpdateNotificationSettingsAction from 'api/actions/user-update-notification-settings/user-update-notification-settings-action';
import createUserPreviewHrNotificationEmailAction from 'api/actions/user-preview-hr-notification-email/user-preview-hr-notification-email-action';
import createUserGetMyCertificatesAction from 'api/actions/user-get-my-certificates/user-get-my-certificates-action';
import createUserRequalifyCertificateAction from 'api/actions/user-requalify-certificate/user-requalify-certificate-action';
import createUserGetMyCompanyQualificationsAction from 'api/actions/user-get-my-company-qualifications/user-get-my-company-qualifications-action';
import createUserGetFollowedDepartmentsListAction from 'api/actions/user-get-followed-departments-list/user-get-followed-departments-list-action';
import createUserGetTableProfilesAction from 'api/actions/user-get-table-profiles/user-get-table-profiles-action';
import createUserSetTableProfilesAction from 'api/actions/user-set-table-profiles/user-set-table-profiles-action';
import createUserCopyTableProfilesAction from 'api/actions/user-copy-table-profiles/user-copy-table-profiles-action';
import createUserSendTestEmailAction from 'api/actions/user-send-test-email/user-send-test-email-action';
import createRevisionTemplateSetBlacklistAction from 'api/actions/revision-template-set-blacklist/revision-template-set-blacklist-action';
import createRevisionTemplateListAction from 'api/actions/revision-template-list/revision-template-list-action';
import createRevisionTemplateGetAction from 'api/actions/revision-template-get/revision-template-get-action';
import createRevisionTemplateCheckPermissionsAction from 'api/actions/revision-template-check-permissions/revision-template-check-permissions-action';
import createRevisionTemplateCreateAction from 'api/actions/revision-template-create/revision-template-create-action';
import createRevisionTemplateUpdateAction from 'api/actions/revision-template-update/revision-template-update-action';
import createRevisionTemplateConfigureAction from 'api/actions/revision-template-configure/revision-template-configure-action';
import createRevisionTemplateSetStatusAction from 'api/actions/revision-template-set-status/revision-template-set-status-action';
import createHrListPeopleAction from 'api/actions/hr-list-people/hr-list-people-action';
import createHrCreatePersonAction from 'api/actions/hr-create-person/hr-create-person-action';
import createHrBulkUpdatePeopleEvidenceAction from 'api/actions/hr-bulk-update-people-evidence/hr-bulk-update-people-evidence-action';
import createHrGetPersonFormOptionsAction from 'api/actions/hr-get-person-form-options/hr-get-person-form-options-action';
import createHrGetPersonAction from 'api/actions/hr-get-person/hr-get-person-action';
import createHrUpdatePersonAction from 'api/actions/hr-update-person/hr-update-person-action';
import createHrSetPersonStatusAction from 'api/actions/hr-set-person-status/hr-set-person-status-action';
import createHrListPersonFilesAction from 'api/actions/hr-list-person-files/hr-list-person-files-action';
import createHrAddPersonFilesAction from 'api/actions/hr-add-person-files/hr-add-person-files-action';
import createHrUpdatePersonFileAction from 'api/actions/hr-update-person-file/hr-update-person-file-action';
import createHrDeletePersonFileAction from 'api/actions/hr-delete-person-file/hr-delete-person-file-action';
import createHrListPersonActivityAction from 'api/actions/hr-list-person-activity/hr-list-person-activity-action';
import createHrListTermsAction from 'api/actions/hr-list-terms/hr-list-terms-action';
import createHrBulkCreateTermsAction from 'api/actions/hr-bulk-create-terms/hr-bulk-create-terms-action';
import createHrGetTermAction from 'api/actions/hr-get-term/hr-get-term-action';
import createHrUpdateTermAction from 'api/actions/hr-update-term/hr-update-term-action';
import createHrCreateTermAction from 'api/actions/hr-create-term/hr-create-term-action';
import createHrSetTermStatusAction from 'api/actions/hr-set-term-status/hr-set-term-status-action';
import createHrExecuteTermAction from 'api/actions/hr-execute-term/hr-execute-term-action';
import createHrBulkUpdateTermsAction from 'api/actions/hr-bulk-update-terms/hr-bulk-update-terms-action';
import createHrListTermHistoryAction from 'api/actions/hr-list-term-history/hr-list-term-history-action';
import createHrListTermTypesAction from 'api/actions/hr-list-term-types/hr-list-term-types-action';
import createHrCreateTermTypeAction from 'api/actions/hr-create-term-type/hr-create-term-type-action';
import createHrUpdateTermTypeAction from 'api/actions/hr-update-term-type/hr-update-term-type-action';
import createHrSetTermTypeStatusAction from 'api/actions/hr-set-term-type-status/hr-set-term-type-status-action';
import createHrListFileCategoriesAction from 'api/actions/hr-list-file-categories/hr-list-file-categories-action';
import createHrCreateFileCategoryAction from 'api/actions/hr-create-file-category/hr-create-file-category-action';
import createHrUpdateFileCategoryAction from 'api/actions/hr-update-file-category/hr-update-file-category-action';
import createHrSetFileCategoryStatusAction from 'api/actions/hr-set-file-category-status/hr-set-file-category-status-action';
import createHrPairCertificateAction from 'api/actions/hr-pair-certificate/hr-pair-certificate-action';
import createHrUnpairCertificateAction from 'api/actions/hr-unpair-certificate/hr-unpair-certificate-action';
import createHrListCertificateOptionsAction from 'api/actions/hr-list-certificate-options/hr-list-certificate-options-action';
import createHierarchyListAction from 'api/actions/hierarchy-list/hierarchy-list-action';
import createHierarchyAvailableLevelsAction from 'api/actions/hierarchy-available-levels/hierarchy-available-levels-action';
import createHierarchyGetAction from 'api/actions/hierarchy-get/hierarchy-get-action';
import createHierarchyCreateAction from 'api/actions/hierarchy-create/hierarchy-create-action';
import createHierarchyUpdateAction from 'api/actions/hierarchy-update/hierarchy-update-action';
import createHierarchySetStatusAction from 'api/actions/hierarchy-set-status/hierarchy-set-status-action';
import createRevisionListAction from 'api/actions/revision-list/revision-list-action';
import createRevisionGetAction from 'api/actions/revision-get/revision-get-action';
import createRevisionCreateAction from 'api/actions/revision-create/revision-create-action';
import createRevisionUpdateAction from 'api/actions/revision-update/revision-update-action';
import createRevisionSetTemplateAction from 'api/actions/revision-set-template/revision-set-template-action';
import createRevisionGetPlanAssignmentsAction from 'api/actions/revision-get-plan-assignments/revision-get-plan-assignments-action';
import createRevisionSavePlanAssignmentsAction from 'api/actions/revision-save-plan-assignments/revision-save-plan-assignments-action';
import createRevisionCreatePlanAssignmentRevisionPlanAction from 'api/actions/revision-create-plan-assignment-revision-plan/revision-create-plan-assignment-revision-plan-action';
import createRevisionSaveDraftAction from 'api/actions/revision-save-draft/revision-save-draft-action';
import createRevisionReindexAction from 'api/actions/revision-reindex/revision-reindex-action';
import createRevisionDeleteAction from 'api/actions/revision-delete/revision-delete-action';
import createRevisionReassignAction from 'api/actions/revision-reassign/revision-reassign-action';
import createRevisionTechnicianDeclineAction from 'api/actions/revision-technician-decline/revision-technician-decline-action';
import createRevisionTechnicianAcceptAction from 'api/actions/revision-technician-accept/revision-technician-accept-action';
import createRevisionAssignToSelfAction from 'api/actions/revision-assign-to-self/revision-assign-to-self-action';
import createRevisionTechnicianSubmitAction from 'api/actions/revision-technician-submit/revision-technician-submit-action';
import createRevisionDelegateAction from 'api/actions/revision-delegate/revision-delegate-action';
import createRevisionDelegateAcceptAction from 'api/actions/revision-delegate-accept/revision-delegate-accept-action';
import createRevisionDelegateRejectAction from 'api/actions/revision-delegate-reject/revision-delegate-reject-action';
import createRevisionDelegateRemoveAction from 'api/actions/revision-delegate-remove/revision-delegate-remove-action';
import createRevisionRejectAction from 'api/actions/revision-reject/revision-reject-action';
import createRevisionApproveAction from 'api/actions/revision-approve/revision-approve-action';
import createRevisionResumeWorkAction from 'api/actions/revision-resume-work/revision-resume-work-action';
import createRevisionCustomerReturnAction from 'api/actions/revision-customer-return/revision-customer-return-action';
import createRevisionCustomerConfirmAction from 'api/actions/revision-customer-confirm/revision-customer-confirm-action';
import createRevisionListExecutingCompaniesOptionsAction from 'api/actions/revision-list-executing-companies-options/revision-list-executing-companies-options-action';
import createRevisionListTechniciansAction from 'api/actions/revision-list-technicians/revision-list-technicians-action';
import createRevisionSignDocAction from 'api/actions/revision-sign-doc/revision-sign-doc-action';
import createRevisionSignMultipleDocsAction from 'api/actions/revision-sign-multiple-docs/revision-sign-multiple-docs-action';
import createRevisionSaveSignedDocAction from 'api/actions/revision-save-signed-doc/revision-save-signed-doc-action';
import createRevisionGetArchiveClauseAction from 'api/actions/revision-get-archive-clause/revision-get-archive-clause-action';
import createRevisionGetArchiveClauseHistoryAction from 'api/actions/revision-get-archive-clause-history/revision-get-archive-clause-history-action';
import createRevisionListTemplatesAction from 'api/actions/revision-list-templates/revision-list-templates-action';
import createRevisionRevisionRerunAutomationsAction from 'api/actions/revision-revision-rerun-automations/revision-revision-rerun-automations-action';
import createRevisionRevisionReimportFaultsFromMeasurementsAction from 'api/actions/revision-revision-reimport-faults-from-measurements/revision-revision-reimport-faults-from-measurements-action';
import createRevisionLockAction from 'api/actions/revision-lock/revision-lock-action';
import createRevisionUnlockAction from 'api/actions/revision-unlock/revision-unlock-action';
import createRevisionGetLockStatusAction from 'api/actions/revision-get-lock-status/revision-get-lock-status-action';
import createRevisionHeartbeatAction from 'api/actions/revision-heartbeat/revision-heartbeat-action';
import createRevisionRequestTakeoverAction from 'api/actions/revision-request-takeover/revision-request-takeover-action';
import createRevisionForceTakeoverAction from 'api/actions/revision-force-takeover/revision-force-takeover-action';
import createOrganizationListAction from 'api/actions/organization-list/organization-list-action';
import createOrganizationGetAction from 'api/actions/organization-get/organization-get-action';
import createOrganizationCreateAction from 'api/actions/organization-create/organization-create-action';
import createOrganizationUpdateAction from 'api/actions/organization-update/organization-update-action';
import createOrganizationSetStatusAction from 'api/actions/organization-set-status/organization-set-status-action';
import createDepartmentListAction from 'api/actions/department-list/department-list-action';
import createDepartmentGetAction from 'api/actions/department-get/department-get-action';
import createDepartmentCreateAction from 'api/actions/department-create/department-create-action';
import createDepartmentUpdateAction from 'api/actions/department-update/department-update-action';
import createDepartmentSetStatusAction from 'api/actions/department-set-status/department-set-status-action';
import createDepartmentGetContactPersonsAction from 'api/actions/department-get-contact-persons/department-get-contact-persons-action';
import createChastiaCreateRevisionAction from 'api/actions/chastia-create-revision/chastia-create-revision-action';
import { AxiosInstance } from 'axios';

/**
 * All action names.
 */
export type ActionName =
  | 'RemoteSourceList'
  | 'RemoteSourceGet'
  | 'RemoteSourceCreate'
  | 'RemoteSourceUpdate'
  | 'RemoteSourceSetStatus'
  | 'RemoteSourceUpdateConfig'
  | 'RemoteSourceSyncDevice'
  | 'XlsxImportDevice'
  | 'XlsxImportRevisionPlan'
  | 'XlsxImportDeviceFault'
  | 'MeasuringDeviceList'
  | 'MeasuringDeviceGet'
  | 'MeasuringDeviceCreate'
  | 'MeasuringDeviceUpdate'
  | 'MeasuringDeviceDelete'
  | 'MeasuringDeviceRevisionGet'
  | 'PredefinedDataListUsers'
  | 'PredefinedDataListGlobal'
  | 'PredefinedDataGetUsers'
  | 'PredefinedDataGetGlobal'
  | 'PredefinedDataCreateUsers'
  | 'PredefinedDataCreateGlobal'
  | 'PredefinedDataUpdateUsers'
  | 'PredefinedDataUpdateGlobal'
  | 'PredefinedDataDeleteUsers'
  | 'PredefinedDataDeleteGlobal'
  | 'PredefinedDataListTypes'
  | 'PredefinedDataListRevisionData'
  | 'PredefinedDataGetMixed'
  | 'DeviceListEvidenceFieldSections'
  | 'DeviceCreateEvidenceFieldSection'
  | 'DeviceUpdateEvidenceFieldSection'
  | 'DeviceDeleteEvidenceFieldSection'
  | 'DeviceList'
  | 'DeviceGet'
  | 'DeviceQrCheck'
  | 'DeviceQrPair'
  | 'DeviceQrResolve'
  | 'DeviceCreate'
  | 'DeviceUpdate'
  | 'DeviceAdminSetRemoteSource'
  | 'DeviceCanMoveToDepartment'
  | 'DeviceSetStatus'
  | 'DeviceListAllFaults'
  | 'DeviceListFaults'
  | 'DeviceFaultFixerGetOptions'
  | 'DeviceFaultAuditUserGetOptions'
  | 'DeviceMarkFaultFixed'
  | 'DeviceListTypes'
  | 'DeviceListSubtypes'
  | 'DeviceSubtypeCreate'
  | 'DeviceSubtypeGet'
  | 'DeviceSubtypeUpdate'
  | 'DeviceSubtypeSetStatus'
  | 'DeviceListRevisionPlan'
  | 'DeviceResponsiblePersonGetOptions'
  | 'DeviceRevisionGetOptions'
  | 'DeviceActiveTypes'
  | 'DeviceListAllEvidenceFields'
  | 'DeviceListEvidenceFields'
  | 'DeviceCreateEvidenceField'
  | 'DeviceUpdateEvidenceField'
  | 'DeviceDeleteEvidenceField'
  | 'PriceOfferList'
  | 'PriceOfferGet'
  | 'PriceOfferCreate'
  | 'PriceOfferCreateBulk'
  | 'PriceOfferSubmit'
  | 'PriceOfferClose'
  | 'PriceOfferReturn'
  | 'PriceOfferDelete'
  | 'PriceOfferListProviders'
  | 'SystemExportDepartmentFiles'
  | 'SystemExportList'
  | 'SystemExportCreate'
  | 'SystemExportDelete'
  | 'AuthLogin'
  | 'AuthLoggedUserInfo'
  | 'AuthVerifyTwoFactorLogin'
  | 'AuthTwoFactorStartSetup'
  | 'AuthTwoFactorConfirmSetup'
  | 'AuthTwoFactorDisable'
  | 'AuthLogout'
  | 'AuthLogout_2'
  | 'AuthForgotPassword'
  | 'AuthResetPassword'
  | 'AuthCheckResetPasswordToken'
  | 'AuthListRoles'
  | 'AuthListPermissions'
  | 'AuthListPermissionTemplates'
  | 'AuthListFaultSeverities'
  | 'AuthUserHasPermissionInDepartment'
  | 'AuthRemoveUserOrganizationPairs'
  | 'AuthRemoveUserDepartmentPairs'
  | 'AuthSetUserOrganizationPermissions'
  | 'AuthSetUserDepartmentPermissions'
  | 'AuthAddUserOrganizationPairs'
  | 'AuthAddUserDepartmentPairs'
  | 'AuthUserGetPermissionsInDepartment'
  | 'AuthGetDepartmentsWithPermission'
  | 'AuthGetOrganizationsWithPermission'
  | 'AuthLogError'
  | 'SystemHealthCheck'
  | 'SystemRunCron'
  | 'UserList'
  | 'UserGet'
  | 'UserCreate'
  | 'UserUpdateMe'
  | 'UserUpdateMyCertificates'
  | 'UserUpdateMyCompanySettings'
  | 'UserUpdate'
  | 'UserChangePassword'
  | 'UserAdminChangePassword'
  | 'UserAdminSetPasswordValidity'
  | 'UserSetStatus'
  | 'UserGetNotificationSettings'
  | 'UserUpdateNotificationSettings'
  | 'UserPreviewHrNotificationEmail'
  | 'UserGetMyCertificates'
  | 'UserRequalifyCertificate'
  | 'UserGetMyCompanyQualifications'
  | 'UserGetFollowedDepartmentsList'
  | 'UserGetTableProfiles'
  | 'UserSetTableProfiles'
  | 'UserCopyTableProfiles'
  | 'UserSendTestEmail'
  | 'RevisionTemplateSetBlacklist'
  | 'RevisionTemplateList'
  | 'RevisionTemplateGet'
  | 'RevisionTemplateCheckPermissions'
  | 'RevisionTemplateCreate'
  | 'RevisionTemplateUpdate'
  | 'RevisionTemplateConfigure'
  | 'RevisionTemplateSetStatus'
  | 'HrListPeople'
  | 'HrCreatePerson'
  | 'HrBulkUpdatePeopleEvidence'
  | 'HrGetPersonFormOptions'
  | 'HrGetPerson'
  | 'HrUpdatePerson'
  | 'HrSetPersonStatus'
  | 'HrListPersonFiles'
  | 'HrAddPersonFiles'
  | 'HrUpdatePersonFile'
  | 'HrDeletePersonFile'
  | 'HrListPersonActivity'
  | 'HrListTerms'
  | 'HrBulkCreateTerms'
  | 'HrGetTerm'
  | 'HrUpdateTerm'
  | 'HrCreateTerm'
  | 'HrSetTermStatus'
  | 'HrExecuteTerm'
  | 'HrBulkUpdateTerms'
  | 'HrListTermHistory'
  | 'HrListTermTypes'
  | 'HrCreateTermType'
  | 'HrUpdateTermType'
  | 'HrSetTermTypeStatus'
  | 'HrListFileCategories'
  | 'HrCreateFileCategory'
  | 'HrUpdateFileCategory'
  | 'HrSetFileCategoryStatus'
  | 'HrPairCertificate'
  | 'HrUnpairCertificate'
  | 'HrListCertificateOptions'
  | 'HierarchyList'
  | 'HierarchyAvailableLevels'
  | 'HierarchyGet'
  | 'HierarchyCreate'
  | 'HierarchyUpdate'
  | 'HierarchySetStatus'
  | 'RevisionList'
  | 'RevisionGet'
  | 'RevisionCreate'
  | 'RevisionUpdate'
  | 'RevisionSetTemplate'
  | 'RevisionGetPlanAssignments'
  | 'RevisionSavePlanAssignments'
  | 'RevisionCreatePlanAssignmentRevisionPlan'
  | 'RevisionSaveDraft'
  | 'RevisionReindex'
  | 'RevisionDelete'
  | 'RevisionReassign'
  | 'RevisionTechnicianDecline'
  | 'RevisionTechnicianAccept'
  | 'RevisionAssignToSelf'
  | 'RevisionTechnicianSubmit'
  | 'RevisionDelegate'
  | 'RevisionDelegateAccept'
  | 'RevisionDelegateReject'
  | 'RevisionDelegateRemove'
  | 'RevisionReject'
  | 'RevisionApprove'
  | 'RevisionResumeWork'
  | 'RevisionCustomerReturn'
  | 'RevisionCustomerConfirm'
  | 'RevisionListExecutingCompaniesOptions'
  | 'RevisionListTechnicians'
  | 'RevisionSignDoc'
  | 'RevisionSignMultipleDocs'
  | 'RevisionSaveSignedDoc'
  | 'RevisionGetArchiveClause'
  | 'RevisionGetArchiveClauseHistory'
  | 'RevisionListTemplates'
  | 'RevisionRevisionRerunAutomations'
  | 'RevisionRevisionReimportFaultsFromMeasurements'
  | 'RevisionLock'
  | 'RevisionUnlock'
  | 'RevisionGetLockStatus'
  | 'RevisionHeartbeat'
  | 'RevisionRequestTakeover'
  | 'RevisionForceTakeover'
  | 'OrganizationList'
  | 'OrganizationGet'
  | 'OrganizationCreate'
  | 'OrganizationUpdate'
  | 'OrganizationSetStatus'
  | 'DepartmentList'
  | 'DepartmentGet'
  | 'DepartmentCreate'
  | 'DepartmentUpdate'
  | 'DepartmentSetStatus'
  | 'DepartmentGetContactPersons'
  | 'ChastiaCreateRevision';

/**
 * Overloads for the getAction function.
 */
export type GetActionMap = ((action: 'RemoteSourceList') => ReturnType<typeof createRemoteSourceListAction>) &
  ((action: 'RemoteSourceGet') => ReturnType<typeof createRemoteSourceGetAction>) &
  ((action: 'RemoteSourceCreate') => ReturnType<typeof createRemoteSourceCreateAction>) &
  ((action: 'RemoteSourceUpdate') => ReturnType<typeof createRemoteSourceUpdateAction>) &
  ((action: 'RemoteSourceSetStatus') => ReturnType<typeof createRemoteSourceSetStatusAction>) &
  ((action: 'RemoteSourceUpdateConfig') => ReturnType<typeof createRemoteSourceUpdateConfigAction>) &
  ((action: 'RemoteSourceSyncDevice') => ReturnType<typeof createRemoteSourceSyncDeviceAction>) &
  ((action: 'XlsxImportDevice') => ReturnType<typeof createXlsxImportDeviceAction>) &
  ((action: 'XlsxImportRevisionPlan') => ReturnType<typeof createXlsxImportRevisionPlanAction>) &
  ((action: 'XlsxImportDeviceFault') => ReturnType<typeof createXlsxImportDeviceFaultAction>) &
  ((action: 'MeasuringDeviceList') => ReturnType<typeof createMeasuringDeviceListAction>) &
  ((action: 'MeasuringDeviceGet') => ReturnType<typeof createMeasuringDeviceGetAction>) &
  ((action: 'MeasuringDeviceCreate') => ReturnType<typeof createMeasuringDeviceCreateAction>) &
  ((action: 'MeasuringDeviceUpdate') => ReturnType<typeof createMeasuringDeviceUpdateAction>) &
  ((action: 'MeasuringDeviceDelete') => ReturnType<typeof createMeasuringDeviceDeleteAction>) &
  ((action: 'MeasuringDeviceRevisionGet') => ReturnType<typeof createMeasuringDeviceRevisionGetAction>) &
  ((action: 'PredefinedDataListUsers') => ReturnType<typeof createPredefinedDataListUsersAction>) &
  ((action: 'PredefinedDataListGlobal') => ReturnType<typeof createPredefinedDataListGlobalAction>) &
  ((action: 'PredefinedDataGetUsers') => ReturnType<typeof createPredefinedDataGetUsersAction>) &
  ((action: 'PredefinedDataGetGlobal') => ReturnType<typeof createPredefinedDataGetGlobalAction>) &
  ((action: 'PredefinedDataCreateUsers') => ReturnType<typeof createPredefinedDataCreateUsersAction>) &
  ((action: 'PredefinedDataCreateGlobal') => ReturnType<typeof createPredefinedDataCreateGlobalAction>) &
  ((action: 'PredefinedDataUpdateUsers') => ReturnType<typeof createPredefinedDataUpdateUsersAction>) &
  ((action: 'PredefinedDataUpdateGlobal') => ReturnType<typeof createPredefinedDataUpdateGlobalAction>) &
  ((action: 'PredefinedDataDeleteUsers') => ReturnType<typeof createPredefinedDataDeleteUsersAction>) &
  ((action: 'PredefinedDataDeleteGlobal') => ReturnType<typeof createPredefinedDataDeleteGlobalAction>) &
  ((action: 'PredefinedDataListTypes') => ReturnType<typeof createPredefinedDataListTypesAction>) &
  ((action: 'PredefinedDataListRevisionData') => ReturnType<typeof createPredefinedDataListRevisionDataAction>) &
  ((action: 'PredefinedDataGetMixed') => ReturnType<typeof createPredefinedDataGetMixedAction>) &
  ((action: 'DeviceListEvidenceFieldSections') => ReturnType<typeof createDeviceListEvidenceFieldSectionsAction>) &
  ((action: 'DeviceCreateEvidenceFieldSection') => ReturnType<typeof createDeviceCreateEvidenceFieldSectionAction>) &
  ((action: 'DeviceUpdateEvidenceFieldSection') => ReturnType<typeof createDeviceUpdateEvidenceFieldSectionAction>) &
  ((action: 'DeviceDeleteEvidenceFieldSection') => ReturnType<typeof createDeviceDeleteEvidenceFieldSectionAction>) &
  ((action: 'DeviceList') => ReturnType<typeof createDeviceListAction>) &
  ((action: 'DeviceGet') => ReturnType<typeof createDeviceGetAction>) &
  ((action: 'DeviceQrCheck') => ReturnType<typeof createDeviceQrCheckAction>) &
  ((action: 'DeviceQrPair') => ReturnType<typeof createDeviceQrPairAction>) &
  ((action: 'DeviceQrResolve') => ReturnType<typeof createDeviceQrResolveAction>) &
  ((action: 'DeviceCreate') => ReturnType<typeof createDeviceCreateAction>) &
  ((action: 'DeviceUpdate') => ReturnType<typeof createDeviceUpdateAction>) &
  ((action: 'DeviceAdminSetRemoteSource') => ReturnType<typeof createDeviceAdminSetRemoteSourceAction>) &
  ((action: 'DeviceCanMoveToDepartment') => ReturnType<typeof createDeviceCanMoveToDepartmentAction>) &
  ((action: 'DeviceSetStatus') => ReturnType<typeof createDeviceSetStatusAction>) &
  ((action: 'DeviceListAllFaults') => ReturnType<typeof createDeviceListAllFaultsAction>) &
  ((action: 'DeviceListFaults') => ReturnType<typeof createDeviceListFaultsAction>) &
  ((action: 'DeviceFaultFixerGetOptions') => ReturnType<typeof createDeviceFaultFixerGetOptionsAction>) &
  ((action: 'DeviceFaultAuditUserGetOptions') => ReturnType<typeof createDeviceFaultAuditUserGetOptionsAction>) &
  ((action: 'DeviceMarkFaultFixed') => ReturnType<typeof createDeviceMarkFaultFixedAction>) &
  ((action: 'DeviceListTypes') => ReturnType<typeof createDeviceListTypesAction>) &
  ((action: 'DeviceListSubtypes') => ReturnType<typeof createDeviceListSubtypesAction>) &
  ((action: 'DeviceSubtypeCreate') => ReturnType<typeof createDeviceSubtypeCreateAction>) &
  ((action: 'DeviceSubtypeGet') => ReturnType<typeof createDeviceSubtypeGetAction>) &
  ((action: 'DeviceSubtypeUpdate') => ReturnType<typeof createDeviceSubtypeUpdateAction>) &
  ((action: 'DeviceSubtypeSetStatus') => ReturnType<typeof createDeviceSubtypeSetStatusAction>) &
  ((action: 'DeviceListRevisionPlan') => ReturnType<typeof createDeviceListRevisionPlanAction>) &
  ((action: 'DeviceResponsiblePersonGetOptions') => ReturnType<typeof createDeviceResponsiblePersonGetOptionsAction>) &
  ((action: 'DeviceRevisionGetOptions') => ReturnType<typeof createDeviceRevisionGetOptionsAction>) &
  ((action: 'DeviceActiveTypes') => ReturnType<typeof createDeviceActiveTypesAction>) &
  ((action: 'DeviceListAllEvidenceFields') => ReturnType<typeof createDeviceListAllEvidenceFieldsAction>) &
  ((action: 'DeviceListEvidenceFields') => ReturnType<typeof createDeviceListEvidenceFieldsAction>) &
  ((action: 'DeviceCreateEvidenceField') => ReturnType<typeof createDeviceCreateEvidenceFieldAction>) &
  ((action: 'DeviceUpdateEvidenceField') => ReturnType<typeof createDeviceUpdateEvidenceFieldAction>) &
  ((action: 'DeviceDeleteEvidenceField') => ReturnType<typeof createDeviceDeleteEvidenceFieldAction>) &
  ((action: 'PriceOfferList') => ReturnType<typeof createPriceOfferListAction>) &
  ((action: 'PriceOfferGet') => ReturnType<typeof createPriceOfferGetAction>) &
  ((action: 'PriceOfferCreate') => ReturnType<typeof createPriceOfferCreateAction>) &
  ((action: 'PriceOfferCreateBulk') => ReturnType<typeof createPriceOfferCreateBulkAction>) &
  ((action: 'PriceOfferSubmit') => ReturnType<typeof createPriceOfferSubmitAction>) &
  ((action: 'PriceOfferClose') => ReturnType<typeof createPriceOfferCloseAction>) &
  ((action: 'PriceOfferReturn') => ReturnType<typeof createPriceOfferReturnAction>) &
  ((action: 'PriceOfferDelete') => ReturnType<typeof createPriceOfferDeleteAction>) &
  ((action: 'PriceOfferListProviders') => ReturnType<typeof createPriceOfferListProvidersAction>) &
  ((action: 'SystemExportDepartmentFiles') => ReturnType<typeof createSystemExportDepartmentFilesAction>) &
  ((action: 'SystemExportList') => ReturnType<typeof createSystemExportListAction>) &
  ((action: 'SystemExportCreate') => ReturnType<typeof createSystemExportCreateAction>) &
  ((action: 'SystemExportDelete') => ReturnType<typeof createSystemExportDeleteAction>) &
  ((action: 'AuthLogin') => ReturnType<typeof createAuthLoginAction>) &
  ((action: 'AuthLoggedUserInfo') => ReturnType<typeof createAuthLoggedUserInfoAction>) &
  ((action: 'AuthVerifyTwoFactorLogin') => ReturnType<typeof createAuthVerifyTwoFactorLoginAction>) &
  ((action: 'AuthTwoFactorStartSetup') => ReturnType<typeof createAuthTwoFactorStartSetupAction>) &
  ((action: 'AuthTwoFactorConfirmSetup') => ReturnType<typeof createAuthTwoFactorConfirmSetupAction>) &
  ((action: 'AuthTwoFactorDisable') => ReturnType<typeof createAuthTwoFactorDisableAction>) &
  ((action: 'AuthLogout') => ReturnType<typeof createAuthLogoutAction>) &
  ((action: 'AuthLogout_2') => ReturnType<typeof createAuthLogout_2Action>) &
  ((action: 'AuthForgotPassword') => ReturnType<typeof createAuthForgotPasswordAction>) &
  ((action: 'AuthResetPassword') => ReturnType<typeof createAuthResetPasswordAction>) &
  ((action: 'AuthCheckResetPasswordToken') => ReturnType<typeof createAuthCheckResetPasswordTokenAction>) &
  ((action: 'AuthListRoles') => ReturnType<typeof createAuthListRolesAction>) &
  ((action: 'AuthListPermissions') => ReturnType<typeof createAuthListPermissionsAction>) &
  ((action: 'AuthListPermissionTemplates') => ReturnType<typeof createAuthListPermissionTemplatesAction>) &
  ((action: 'AuthListFaultSeverities') => ReturnType<typeof createAuthListFaultSeveritiesAction>) &
  ((action: 'AuthUserHasPermissionInDepartment') => ReturnType<typeof createAuthUserHasPermissionInDepartmentAction>) &
  ((action: 'AuthRemoveUserOrganizationPairs') => ReturnType<typeof createAuthRemoveUserOrganizationPairsAction>) &
  ((action: 'AuthRemoveUserDepartmentPairs') => ReturnType<typeof createAuthRemoveUserDepartmentPairsAction>) &
  ((
    action: 'AuthSetUserOrganizationPermissions'
  ) => ReturnType<typeof createAuthSetUserOrganizationPermissionsAction>) &
  ((action: 'AuthSetUserDepartmentPermissions') => ReturnType<typeof createAuthSetUserDepartmentPermissionsAction>) &
  ((action: 'AuthAddUserOrganizationPairs') => ReturnType<typeof createAuthAddUserOrganizationPairsAction>) &
  ((action: 'AuthAddUserDepartmentPairs') => ReturnType<typeof createAuthAddUserDepartmentPairsAction>) &
  ((
    action: 'AuthUserGetPermissionsInDepartment'
  ) => ReturnType<typeof createAuthUserGetPermissionsInDepartmentAction>) &
  ((action: 'AuthGetDepartmentsWithPermission') => ReturnType<typeof createAuthGetDepartmentsWithPermissionAction>) &
  ((
    action: 'AuthGetOrganizationsWithPermission'
  ) => ReturnType<typeof createAuthGetOrganizationsWithPermissionAction>) &
  ((action: 'AuthLogError') => ReturnType<typeof createAuthLogErrorAction>) &
  ((action: 'SystemHealthCheck') => ReturnType<typeof createSystemHealthCheckAction>) &
  ((action: 'SystemRunCron') => ReturnType<typeof createSystemRunCronAction>) &
  ((action: 'UserList') => ReturnType<typeof createUserListAction>) &
  ((action: 'UserGet') => ReturnType<typeof createUserGetAction>) &
  ((action: 'UserCreate') => ReturnType<typeof createUserCreateAction>) &
  ((action: 'UserUpdateMe') => ReturnType<typeof createUserUpdateMeAction>) &
  ((action: 'UserUpdateMyCertificates') => ReturnType<typeof createUserUpdateMyCertificatesAction>) &
  ((action: 'UserUpdateMyCompanySettings') => ReturnType<typeof createUserUpdateMyCompanySettingsAction>) &
  ((action: 'UserUpdate') => ReturnType<typeof createUserUpdateAction>) &
  ((action: 'UserChangePassword') => ReturnType<typeof createUserChangePasswordAction>) &
  ((action: 'UserAdminChangePassword') => ReturnType<typeof createUserAdminChangePasswordAction>) &
  ((action: 'UserAdminSetPasswordValidity') => ReturnType<typeof createUserAdminSetPasswordValidityAction>) &
  ((action: 'UserSetStatus') => ReturnType<typeof createUserSetStatusAction>) &
  ((action: 'UserGetNotificationSettings') => ReturnType<typeof createUserGetNotificationSettingsAction>) &
  ((action: 'UserUpdateNotificationSettings') => ReturnType<typeof createUserUpdateNotificationSettingsAction>) &
  ((action: 'UserPreviewHrNotificationEmail') => ReturnType<typeof createUserPreviewHrNotificationEmailAction>) &
  ((action: 'UserGetMyCertificates') => ReturnType<typeof createUserGetMyCertificatesAction>) &
  ((action: 'UserRequalifyCertificate') => ReturnType<typeof createUserRequalifyCertificateAction>) &
  ((action: 'UserGetMyCompanyQualifications') => ReturnType<typeof createUserGetMyCompanyQualificationsAction>) &
  ((action: 'UserGetFollowedDepartmentsList') => ReturnType<typeof createUserGetFollowedDepartmentsListAction>) &
  ((action: 'UserGetTableProfiles') => ReturnType<typeof createUserGetTableProfilesAction>) &
  ((action: 'UserSetTableProfiles') => ReturnType<typeof createUserSetTableProfilesAction>) &
  ((action: 'UserCopyTableProfiles') => ReturnType<typeof createUserCopyTableProfilesAction>) &
  ((action: 'UserSendTestEmail') => ReturnType<typeof createUserSendTestEmailAction>) &
  ((action: 'RevisionTemplateSetBlacklist') => ReturnType<typeof createRevisionTemplateSetBlacklistAction>) &
  ((action: 'RevisionTemplateList') => ReturnType<typeof createRevisionTemplateListAction>) &
  ((action: 'RevisionTemplateGet') => ReturnType<typeof createRevisionTemplateGetAction>) &
  ((action: 'RevisionTemplateCheckPermissions') => ReturnType<typeof createRevisionTemplateCheckPermissionsAction>) &
  ((action: 'RevisionTemplateCreate') => ReturnType<typeof createRevisionTemplateCreateAction>) &
  ((action: 'RevisionTemplateUpdate') => ReturnType<typeof createRevisionTemplateUpdateAction>) &
  ((action: 'RevisionTemplateConfigure') => ReturnType<typeof createRevisionTemplateConfigureAction>) &
  ((action: 'RevisionTemplateSetStatus') => ReturnType<typeof createRevisionTemplateSetStatusAction>) &
  ((action: 'HrListPeople') => ReturnType<typeof createHrListPeopleAction>) &
  ((action: 'HrCreatePerson') => ReturnType<typeof createHrCreatePersonAction>) &
  ((action: 'HrBulkUpdatePeopleEvidence') => ReturnType<typeof createHrBulkUpdatePeopleEvidenceAction>) &
  ((action: 'HrGetPersonFormOptions') => ReturnType<typeof createHrGetPersonFormOptionsAction>) &
  ((action: 'HrGetPerson') => ReturnType<typeof createHrGetPersonAction>) &
  ((action: 'HrUpdatePerson') => ReturnType<typeof createHrUpdatePersonAction>) &
  ((action: 'HrSetPersonStatus') => ReturnType<typeof createHrSetPersonStatusAction>) &
  ((action: 'HrListPersonFiles') => ReturnType<typeof createHrListPersonFilesAction>) &
  ((action: 'HrAddPersonFiles') => ReturnType<typeof createHrAddPersonFilesAction>) &
  ((action: 'HrUpdatePersonFile') => ReturnType<typeof createHrUpdatePersonFileAction>) &
  ((action: 'HrDeletePersonFile') => ReturnType<typeof createHrDeletePersonFileAction>) &
  ((action: 'HrListPersonActivity') => ReturnType<typeof createHrListPersonActivityAction>) &
  ((action: 'HrListTerms') => ReturnType<typeof createHrListTermsAction>) &
  ((action: 'HrBulkCreateTerms') => ReturnType<typeof createHrBulkCreateTermsAction>) &
  ((action: 'HrGetTerm') => ReturnType<typeof createHrGetTermAction>) &
  ((action: 'HrUpdateTerm') => ReturnType<typeof createHrUpdateTermAction>) &
  ((action: 'HrCreateTerm') => ReturnType<typeof createHrCreateTermAction>) &
  ((action: 'HrSetTermStatus') => ReturnType<typeof createHrSetTermStatusAction>) &
  ((action: 'HrExecuteTerm') => ReturnType<typeof createHrExecuteTermAction>) &
  ((action: 'HrBulkUpdateTerms') => ReturnType<typeof createHrBulkUpdateTermsAction>) &
  ((action: 'HrListTermHistory') => ReturnType<typeof createHrListTermHistoryAction>) &
  ((action: 'HrListTermTypes') => ReturnType<typeof createHrListTermTypesAction>) &
  ((action: 'HrCreateTermType') => ReturnType<typeof createHrCreateTermTypeAction>) &
  ((action: 'HrUpdateTermType') => ReturnType<typeof createHrUpdateTermTypeAction>) &
  ((action: 'HrSetTermTypeStatus') => ReturnType<typeof createHrSetTermTypeStatusAction>) &
  ((action: 'HrListFileCategories') => ReturnType<typeof createHrListFileCategoriesAction>) &
  ((action: 'HrCreateFileCategory') => ReturnType<typeof createHrCreateFileCategoryAction>) &
  ((action: 'HrUpdateFileCategory') => ReturnType<typeof createHrUpdateFileCategoryAction>) &
  ((action: 'HrSetFileCategoryStatus') => ReturnType<typeof createHrSetFileCategoryStatusAction>) &
  ((action: 'HrPairCertificate') => ReturnType<typeof createHrPairCertificateAction>) &
  ((action: 'HrUnpairCertificate') => ReturnType<typeof createHrUnpairCertificateAction>) &
  ((action: 'HrListCertificateOptions') => ReturnType<typeof createHrListCertificateOptionsAction>) &
  ((action: 'HierarchyList') => ReturnType<typeof createHierarchyListAction>) &
  ((action: 'HierarchyAvailableLevels') => ReturnType<typeof createHierarchyAvailableLevelsAction>) &
  ((action: 'HierarchyGet') => ReturnType<typeof createHierarchyGetAction>) &
  ((action: 'HierarchyCreate') => ReturnType<typeof createHierarchyCreateAction>) &
  ((action: 'HierarchyUpdate') => ReturnType<typeof createHierarchyUpdateAction>) &
  ((action: 'HierarchySetStatus') => ReturnType<typeof createHierarchySetStatusAction>) &
  ((action: 'RevisionList') => ReturnType<typeof createRevisionListAction>) &
  ((action: 'RevisionGet') => ReturnType<typeof createRevisionGetAction>) &
  ((action: 'RevisionCreate') => ReturnType<typeof createRevisionCreateAction>) &
  ((action: 'RevisionUpdate') => ReturnType<typeof createRevisionUpdateAction>) &
  ((action: 'RevisionSetTemplate') => ReturnType<typeof createRevisionSetTemplateAction>) &
  ((action: 'RevisionGetPlanAssignments') => ReturnType<typeof createRevisionGetPlanAssignmentsAction>) &
  ((action: 'RevisionSavePlanAssignments') => ReturnType<typeof createRevisionSavePlanAssignmentsAction>) &
  ((
    action: 'RevisionCreatePlanAssignmentRevisionPlan'
  ) => ReturnType<typeof createRevisionCreatePlanAssignmentRevisionPlanAction>) &
  ((action: 'RevisionSaveDraft') => ReturnType<typeof createRevisionSaveDraftAction>) &
  ((action: 'RevisionReindex') => ReturnType<typeof createRevisionReindexAction>) &
  ((action: 'RevisionDelete') => ReturnType<typeof createRevisionDeleteAction>) &
  ((action: 'RevisionReassign') => ReturnType<typeof createRevisionReassignAction>) &
  ((action: 'RevisionTechnicianDecline') => ReturnType<typeof createRevisionTechnicianDeclineAction>) &
  ((action: 'RevisionTechnicianAccept') => ReturnType<typeof createRevisionTechnicianAcceptAction>) &
  ((action: 'RevisionAssignToSelf') => ReturnType<typeof createRevisionAssignToSelfAction>) &
  ((action: 'RevisionTechnicianSubmit') => ReturnType<typeof createRevisionTechnicianSubmitAction>) &
  ((action: 'RevisionDelegate') => ReturnType<typeof createRevisionDelegateAction>) &
  ((action: 'RevisionDelegateAccept') => ReturnType<typeof createRevisionDelegateAcceptAction>) &
  ((action: 'RevisionDelegateReject') => ReturnType<typeof createRevisionDelegateRejectAction>) &
  ((action: 'RevisionDelegateRemove') => ReturnType<typeof createRevisionDelegateRemoveAction>) &
  ((action: 'RevisionReject') => ReturnType<typeof createRevisionRejectAction>) &
  ((action: 'RevisionApprove') => ReturnType<typeof createRevisionApproveAction>) &
  ((action: 'RevisionResumeWork') => ReturnType<typeof createRevisionResumeWorkAction>) &
  ((action: 'RevisionCustomerReturn') => ReturnType<typeof createRevisionCustomerReturnAction>) &
  ((action: 'RevisionCustomerConfirm') => ReturnType<typeof createRevisionCustomerConfirmAction>) &
  ((
    action: 'RevisionListExecutingCompaniesOptions'
  ) => ReturnType<typeof createRevisionListExecutingCompaniesOptionsAction>) &
  ((action: 'RevisionListTechnicians') => ReturnType<typeof createRevisionListTechniciansAction>) &
  ((action: 'RevisionSignDoc') => ReturnType<typeof createRevisionSignDocAction>) &
  ((action: 'RevisionSignMultipleDocs') => ReturnType<typeof createRevisionSignMultipleDocsAction>) &
  ((action: 'RevisionSaveSignedDoc') => ReturnType<typeof createRevisionSaveSignedDocAction>) &
  ((action: 'RevisionGetArchiveClause') => ReturnType<typeof createRevisionGetArchiveClauseAction>) &
  ((action: 'RevisionGetArchiveClauseHistory') => ReturnType<typeof createRevisionGetArchiveClauseHistoryAction>) &
  ((action: 'RevisionListTemplates') => ReturnType<typeof createRevisionListTemplatesAction>) &
  ((action: 'RevisionRevisionRerunAutomations') => ReturnType<typeof createRevisionRevisionRerunAutomationsAction>) &
  ((
    action: 'RevisionRevisionReimportFaultsFromMeasurements'
  ) => ReturnType<typeof createRevisionRevisionReimportFaultsFromMeasurementsAction>) &
  ((action: 'RevisionLock') => ReturnType<typeof createRevisionLockAction>) &
  ((action: 'RevisionUnlock') => ReturnType<typeof createRevisionUnlockAction>) &
  ((action: 'RevisionGetLockStatus') => ReturnType<typeof createRevisionGetLockStatusAction>) &
  ((action: 'RevisionHeartbeat') => ReturnType<typeof createRevisionHeartbeatAction>) &
  ((action: 'RevisionRequestTakeover') => ReturnType<typeof createRevisionRequestTakeoverAction>) &
  ((action: 'RevisionForceTakeover') => ReturnType<typeof createRevisionForceTakeoverAction>) &
  ((action: 'OrganizationList') => ReturnType<typeof createOrganizationListAction>) &
  ((action: 'OrganizationGet') => ReturnType<typeof createOrganizationGetAction>) &
  ((action: 'OrganizationCreate') => ReturnType<typeof createOrganizationCreateAction>) &
  ((action: 'OrganizationUpdate') => ReturnType<typeof createOrganizationUpdateAction>) &
  ((action: 'OrganizationSetStatus') => ReturnType<typeof createOrganizationSetStatusAction>) &
  ((action: 'DepartmentList') => ReturnType<typeof createDepartmentListAction>) &
  ((action: 'DepartmentGet') => ReturnType<typeof createDepartmentGetAction>) &
  ((action: 'DepartmentCreate') => ReturnType<typeof createDepartmentCreateAction>) &
  ((action: 'DepartmentUpdate') => ReturnType<typeof createDepartmentUpdateAction>) &
  ((action: 'DepartmentSetStatus') => ReturnType<typeof createDepartmentSetStatusAction>) &
  ((action: 'DepartmentGetContactPersons') => ReturnType<typeof createDepartmentGetContactPersonsAction>) &
  ((action: 'ChastiaCreateRevision') => ReturnType<typeof createChastiaCreateRevisionAction>);

/**
 * The map from action name to action creator.
 */
export const actions: Map<ActionName, (axios: AxiosInstance) => Promise<any>> = new Map([
  ['RemoteSourceList', createRemoteSourceListAction],
  ['RemoteSourceGet', createRemoteSourceGetAction],
  ['RemoteSourceCreate', createRemoteSourceCreateAction],
  ['RemoteSourceUpdate', createRemoteSourceUpdateAction],
  ['RemoteSourceSetStatus', createRemoteSourceSetStatusAction],
  ['RemoteSourceUpdateConfig', createRemoteSourceUpdateConfigAction],
  ['RemoteSourceSyncDevice', createRemoteSourceSyncDeviceAction],
  ['XlsxImportDevice', createXlsxImportDeviceAction],
  ['XlsxImportRevisionPlan', createXlsxImportRevisionPlanAction],
  ['XlsxImportDeviceFault', createXlsxImportDeviceFaultAction],
  ['MeasuringDeviceList', createMeasuringDeviceListAction],
  ['MeasuringDeviceGet', createMeasuringDeviceGetAction],
  ['MeasuringDeviceCreate', createMeasuringDeviceCreateAction],
  ['MeasuringDeviceUpdate', createMeasuringDeviceUpdateAction],
  ['MeasuringDeviceDelete', createMeasuringDeviceDeleteAction],
  ['MeasuringDeviceRevisionGet', createMeasuringDeviceRevisionGetAction],
  ['PredefinedDataListUsers', createPredefinedDataListUsersAction],
  ['PredefinedDataListGlobal', createPredefinedDataListGlobalAction],
  ['PredefinedDataGetUsers', createPredefinedDataGetUsersAction],
  ['PredefinedDataGetGlobal', createPredefinedDataGetGlobalAction],
  ['PredefinedDataCreateUsers', createPredefinedDataCreateUsersAction],
  ['PredefinedDataCreateGlobal', createPredefinedDataCreateGlobalAction],
  ['PredefinedDataUpdateUsers', createPredefinedDataUpdateUsersAction],
  ['PredefinedDataUpdateGlobal', createPredefinedDataUpdateGlobalAction],
  ['PredefinedDataDeleteUsers', createPredefinedDataDeleteUsersAction],
  ['PredefinedDataDeleteGlobal', createPredefinedDataDeleteGlobalAction],
  ['PredefinedDataListTypes', createPredefinedDataListTypesAction],
  ['PredefinedDataListRevisionData', createPredefinedDataListRevisionDataAction],
  ['PredefinedDataGetMixed', createPredefinedDataGetMixedAction],
  ['DeviceListEvidenceFieldSections', createDeviceListEvidenceFieldSectionsAction],
  ['DeviceCreateEvidenceFieldSection', createDeviceCreateEvidenceFieldSectionAction],
  ['DeviceUpdateEvidenceFieldSection', createDeviceUpdateEvidenceFieldSectionAction],
  ['DeviceDeleteEvidenceFieldSection', createDeviceDeleteEvidenceFieldSectionAction],
  ['DeviceList', createDeviceListAction],
  ['DeviceGet', createDeviceGetAction],
  ['DeviceQrCheck', createDeviceQrCheckAction],
  ['DeviceQrPair', createDeviceQrPairAction],
  ['DeviceQrResolve', createDeviceQrResolveAction],
  ['DeviceCreate', createDeviceCreateAction],
  ['DeviceUpdate', createDeviceUpdateAction],
  ['DeviceAdminSetRemoteSource', createDeviceAdminSetRemoteSourceAction],
  ['DeviceCanMoveToDepartment', createDeviceCanMoveToDepartmentAction],
  ['DeviceSetStatus', createDeviceSetStatusAction],
  ['DeviceListAllFaults', createDeviceListAllFaultsAction],
  ['DeviceListFaults', createDeviceListFaultsAction],
  ['DeviceFaultFixerGetOptions', createDeviceFaultFixerGetOptionsAction],
  ['DeviceFaultAuditUserGetOptions', createDeviceFaultAuditUserGetOptionsAction],
  ['DeviceMarkFaultFixed', createDeviceMarkFaultFixedAction],
  ['DeviceListTypes', createDeviceListTypesAction],
  ['DeviceListSubtypes', createDeviceListSubtypesAction],
  ['DeviceSubtypeCreate', createDeviceSubtypeCreateAction],
  ['DeviceSubtypeGet', createDeviceSubtypeGetAction],
  ['DeviceSubtypeUpdate', createDeviceSubtypeUpdateAction],
  ['DeviceSubtypeSetStatus', createDeviceSubtypeSetStatusAction],
  ['DeviceListRevisionPlan', createDeviceListRevisionPlanAction],
  ['DeviceResponsiblePersonGetOptions', createDeviceResponsiblePersonGetOptionsAction],
  ['DeviceRevisionGetOptions', createDeviceRevisionGetOptionsAction],
  ['DeviceActiveTypes', createDeviceActiveTypesAction],
  ['DeviceListAllEvidenceFields', createDeviceListAllEvidenceFieldsAction],
  ['DeviceListEvidenceFields', createDeviceListEvidenceFieldsAction],
  ['DeviceCreateEvidenceField', createDeviceCreateEvidenceFieldAction],
  ['DeviceUpdateEvidenceField', createDeviceUpdateEvidenceFieldAction],
  ['DeviceDeleteEvidenceField', createDeviceDeleteEvidenceFieldAction],
  ['PriceOfferList', createPriceOfferListAction],
  ['PriceOfferGet', createPriceOfferGetAction],
  ['PriceOfferCreate', createPriceOfferCreateAction],
  ['PriceOfferCreateBulk', createPriceOfferCreateBulkAction],
  ['PriceOfferSubmit', createPriceOfferSubmitAction],
  ['PriceOfferClose', createPriceOfferCloseAction],
  ['PriceOfferReturn', createPriceOfferReturnAction],
  ['PriceOfferDelete', createPriceOfferDeleteAction],
  ['PriceOfferListProviders', createPriceOfferListProvidersAction],
  ['SystemExportDepartmentFiles', createSystemExportDepartmentFilesAction],
  ['SystemExportList', createSystemExportListAction],
  ['SystemExportCreate', createSystemExportCreateAction],
  ['SystemExportDelete', createSystemExportDeleteAction],
  ['AuthLogin', createAuthLoginAction],
  ['AuthLoggedUserInfo', createAuthLoggedUserInfoAction],
  ['AuthVerifyTwoFactorLogin', createAuthVerifyTwoFactorLoginAction],
  ['AuthTwoFactorStartSetup', createAuthTwoFactorStartSetupAction],
  ['AuthTwoFactorConfirmSetup', createAuthTwoFactorConfirmSetupAction],
  ['AuthTwoFactorDisable', createAuthTwoFactorDisableAction],
  ['AuthLogout', createAuthLogoutAction],
  ['AuthLogout_2', createAuthLogout_2Action],
  ['AuthForgotPassword', createAuthForgotPasswordAction],
  ['AuthResetPassword', createAuthResetPasswordAction],
  ['AuthCheckResetPasswordToken', createAuthCheckResetPasswordTokenAction],
  ['AuthListRoles', createAuthListRolesAction],
  ['AuthListPermissions', createAuthListPermissionsAction],
  ['AuthListPermissionTemplates', createAuthListPermissionTemplatesAction],
  ['AuthListFaultSeverities', createAuthListFaultSeveritiesAction],
  ['AuthUserHasPermissionInDepartment', createAuthUserHasPermissionInDepartmentAction],
  ['AuthRemoveUserOrganizationPairs', createAuthRemoveUserOrganizationPairsAction],
  ['AuthRemoveUserDepartmentPairs', createAuthRemoveUserDepartmentPairsAction],
  ['AuthSetUserOrganizationPermissions', createAuthSetUserOrganizationPermissionsAction],
  ['AuthSetUserDepartmentPermissions', createAuthSetUserDepartmentPermissionsAction],
  ['AuthAddUserOrganizationPairs', createAuthAddUserOrganizationPairsAction],
  ['AuthAddUserDepartmentPairs', createAuthAddUserDepartmentPairsAction],
  ['AuthUserGetPermissionsInDepartment', createAuthUserGetPermissionsInDepartmentAction],
  ['AuthGetDepartmentsWithPermission', createAuthGetDepartmentsWithPermissionAction],
  ['AuthGetOrganizationsWithPermission', createAuthGetOrganizationsWithPermissionAction],
  ['AuthLogError', createAuthLogErrorAction],
  ['SystemHealthCheck', createSystemHealthCheckAction],
  ['SystemRunCron', createSystemRunCronAction],
  ['UserList', createUserListAction],
  ['UserGet', createUserGetAction],
  ['UserCreate', createUserCreateAction],
  ['UserUpdateMe', createUserUpdateMeAction],
  ['UserUpdateMyCertificates', createUserUpdateMyCertificatesAction],
  ['UserUpdateMyCompanySettings', createUserUpdateMyCompanySettingsAction],
  ['UserUpdate', createUserUpdateAction],
  ['UserChangePassword', createUserChangePasswordAction],
  ['UserAdminChangePassword', createUserAdminChangePasswordAction],
  ['UserAdminSetPasswordValidity', createUserAdminSetPasswordValidityAction],
  ['UserSetStatus', createUserSetStatusAction],
  ['UserGetNotificationSettings', createUserGetNotificationSettingsAction],
  ['UserUpdateNotificationSettings', createUserUpdateNotificationSettingsAction],
  ['UserPreviewHrNotificationEmail', createUserPreviewHrNotificationEmailAction],
  ['UserGetMyCertificates', createUserGetMyCertificatesAction],
  ['UserRequalifyCertificate', createUserRequalifyCertificateAction],
  ['UserGetMyCompanyQualifications', createUserGetMyCompanyQualificationsAction],
  ['UserGetFollowedDepartmentsList', createUserGetFollowedDepartmentsListAction],
  ['UserGetTableProfiles', createUserGetTableProfilesAction],
  ['UserSetTableProfiles', createUserSetTableProfilesAction],
  ['UserCopyTableProfiles', createUserCopyTableProfilesAction],
  ['UserSendTestEmail', createUserSendTestEmailAction],
  ['RevisionTemplateSetBlacklist', createRevisionTemplateSetBlacklistAction],
  ['RevisionTemplateList', createRevisionTemplateListAction],
  ['RevisionTemplateGet', createRevisionTemplateGetAction],
  ['RevisionTemplateCheckPermissions', createRevisionTemplateCheckPermissionsAction],
  ['RevisionTemplateCreate', createRevisionTemplateCreateAction],
  ['RevisionTemplateUpdate', createRevisionTemplateUpdateAction],
  ['RevisionTemplateConfigure', createRevisionTemplateConfigureAction],
  ['RevisionTemplateSetStatus', createRevisionTemplateSetStatusAction],
  ['HrListPeople', createHrListPeopleAction],
  ['HrCreatePerson', createHrCreatePersonAction],
  ['HrBulkUpdatePeopleEvidence', createHrBulkUpdatePeopleEvidenceAction],
  ['HrGetPersonFormOptions', createHrGetPersonFormOptionsAction],
  ['HrGetPerson', createHrGetPersonAction],
  ['HrUpdatePerson', createHrUpdatePersonAction],
  ['HrSetPersonStatus', createHrSetPersonStatusAction],
  ['HrListPersonFiles', createHrListPersonFilesAction],
  ['HrAddPersonFiles', createHrAddPersonFilesAction],
  ['HrUpdatePersonFile', createHrUpdatePersonFileAction],
  ['HrDeletePersonFile', createHrDeletePersonFileAction],
  ['HrListPersonActivity', createHrListPersonActivityAction],
  ['HrListTerms', createHrListTermsAction],
  ['HrBulkCreateTerms', createHrBulkCreateTermsAction],
  ['HrGetTerm', createHrGetTermAction],
  ['HrUpdateTerm', createHrUpdateTermAction],
  ['HrCreateTerm', createHrCreateTermAction],
  ['HrSetTermStatus', createHrSetTermStatusAction],
  ['HrExecuteTerm', createHrExecuteTermAction],
  ['HrBulkUpdateTerms', createHrBulkUpdateTermsAction],
  ['HrListTermHistory', createHrListTermHistoryAction],
  ['HrListTermTypes', createHrListTermTypesAction],
  ['HrCreateTermType', createHrCreateTermTypeAction],
  ['HrUpdateTermType', createHrUpdateTermTypeAction],
  ['HrSetTermTypeStatus', createHrSetTermTypeStatusAction],
  ['HrListFileCategories', createHrListFileCategoriesAction],
  ['HrCreateFileCategory', createHrCreateFileCategoryAction],
  ['HrUpdateFileCategory', createHrUpdateFileCategoryAction],
  ['HrSetFileCategoryStatus', createHrSetFileCategoryStatusAction],
  ['HrPairCertificate', createHrPairCertificateAction],
  ['HrUnpairCertificate', createHrUnpairCertificateAction],
  ['HrListCertificateOptions', createHrListCertificateOptionsAction],
  ['HierarchyList', createHierarchyListAction],
  ['HierarchyAvailableLevels', createHierarchyAvailableLevelsAction],
  ['HierarchyGet', createHierarchyGetAction],
  ['HierarchyCreate', createHierarchyCreateAction],
  ['HierarchyUpdate', createHierarchyUpdateAction],
  ['HierarchySetStatus', createHierarchySetStatusAction],
  ['RevisionList', createRevisionListAction],
  ['RevisionGet', createRevisionGetAction],
  ['RevisionCreate', createRevisionCreateAction],
  ['RevisionUpdate', createRevisionUpdateAction],
  ['RevisionSetTemplate', createRevisionSetTemplateAction],
  ['RevisionGetPlanAssignments', createRevisionGetPlanAssignmentsAction],
  ['RevisionSavePlanAssignments', createRevisionSavePlanAssignmentsAction],
  ['RevisionCreatePlanAssignmentRevisionPlan', createRevisionCreatePlanAssignmentRevisionPlanAction],
  ['RevisionSaveDraft', createRevisionSaveDraftAction],
  ['RevisionReindex', createRevisionReindexAction],
  ['RevisionDelete', createRevisionDeleteAction],
  ['RevisionReassign', createRevisionReassignAction],
  ['RevisionTechnicianDecline', createRevisionTechnicianDeclineAction],
  ['RevisionTechnicianAccept', createRevisionTechnicianAcceptAction],
  ['RevisionAssignToSelf', createRevisionAssignToSelfAction],
  ['RevisionTechnicianSubmit', createRevisionTechnicianSubmitAction],
  ['RevisionDelegate', createRevisionDelegateAction],
  ['RevisionDelegateAccept', createRevisionDelegateAcceptAction],
  ['RevisionDelegateReject', createRevisionDelegateRejectAction],
  ['RevisionDelegateRemove', createRevisionDelegateRemoveAction],
  ['RevisionReject', createRevisionRejectAction],
  ['RevisionApprove', createRevisionApproveAction],
  ['RevisionResumeWork', createRevisionResumeWorkAction],
  ['RevisionCustomerReturn', createRevisionCustomerReturnAction],
  ['RevisionCustomerConfirm', createRevisionCustomerConfirmAction],
  ['RevisionListExecutingCompaniesOptions', createRevisionListExecutingCompaniesOptionsAction],
  ['RevisionListTechnicians', createRevisionListTechniciansAction],
  ['RevisionSignDoc', createRevisionSignDocAction],
  ['RevisionSignMultipleDocs', createRevisionSignMultipleDocsAction],
  ['RevisionSaveSignedDoc', createRevisionSaveSignedDocAction],
  ['RevisionGetArchiveClause', createRevisionGetArchiveClauseAction],
  ['RevisionGetArchiveClauseHistory', createRevisionGetArchiveClauseHistoryAction],
  ['RevisionListTemplates', createRevisionListTemplatesAction],
  ['RevisionRevisionRerunAutomations', createRevisionRevisionRerunAutomationsAction],
  ['RevisionRevisionReimportFaultsFromMeasurements', createRevisionRevisionReimportFaultsFromMeasurementsAction],
  ['RevisionLock', createRevisionLockAction],
  ['RevisionUnlock', createRevisionUnlockAction],
  ['RevisionGetLockStatus', createRevisionGetLockStatusAction],
  ['RevisionHeartbeat', createRevisionHeartbeatAction],
  ['RevisionRequestTakeover', createRevisionRequestTakeoverAction],
  ['RevisionForceTakeover', createRevisionForceTakeoverAction],
  ['OrganizationList', createOrganizationListAction],
  ['OrganizationGet', createOrganizationGetAction],
  ['OrganizationCreate', createOrganizationCreateAction],
  ['OrganizationUpdate', createOrganizationUpdateAction],
  ['OrganizationSetStatus', createOrganizationSetStatusAction],
  ['DepartmentList', createDepartmentListAction],
  ['DepartmentGet', createDepartmentGetAction],
  ['DepartmentCreate', createDepartmentCreateAction],
  ['DepartmentUpdate', createDepartmentUpdateAction],
  ['DepartmentSetStatus', createDepartmentSetStatusAction],
  ['DepartmentGetContactPersons', createDepartmentGetContactPersonsAction],
  ['ChastiaCreateRevision', createChastiaCreateRevisionAction],
] as any);
